import { components } from "react-select";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { filterDomainsForComponent } from "../../utils";
import { Actions } from "../../Action/index";
import { useLocation } from "react-router-dom";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import { CurationFilters } from "../../Constants";
import { Select } from "antd";
import debounce from "lodash.debounce";
import { useCallback } from 'react';
const customStyles = {
  control: (base) => ({
    ...base,
    height: 29,
    minHeight: 29,
    marginBottom: 5,
    borderColor: "lightgray",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    color: "lightgray",
  }),
  clearIndicator: (styles) => ({
    ...styles,
    paddingTop: 0,
    paddingBottom: 0,
    color: "lightgray",
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isFocused
      ? "var(--light_color_shade)"
      : state.isSelected
        ? "var(--light_color_shade)"
        : "none",
    color: state.isFocused ? "#fff" : state.isSelected ? "#fff" : "none",
  }),
};

const ValueContainer = ({ children, ...props }) => {
  let [values, input] = children;
  if (Array.isArray(values)) {
    const plural = values.length === 1 ? "" : "s";
    values = `${values.length} selected`;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

const NewNestedSelect = ({ tabsearchQuery, show, setCurationFilter, setHeadFilter,
  setSelectedFilters }) => {
  const dispatch = useDispatch();
  const { expertAnsweredFilter, changeCurationStatus, AnsweredPageBool, expertCurationChange, expertDomainChange,updatePageNoAnswered ,getScrollPositionInExpertOpen} =
    bindActionCreators(Actions, dispatch);
  const userData = useSelector((state) => state.user);
  const expertAnsweredState = useSelector((state) => state.answeredQuestions);
  let pageState = useSelector((state) => state.answeredQuestions);
  const [selectedDomains, setSelectedDomains] = useState([]);
  const [domain, setDomain] = useState(pageState.expertDomain || []);

  const num = ["1", "2", "3"]; // identifiers for curation values

  const options = [
    {
      label: "Select Domains",
      options: filterDomainsForComponent(userData.expertTopics),
    },
  ];

  const curationFilter = [
    {
      label: "Needs Curation",
      options: CurationFilters,
    },
  ];
  // console.log("pageState",pageState)

const debouncedFetchOptions = useCallback(
    debounce((value) => {
      getScrollPositionInExpertOpen(null)
    updatePageNoAnswered(0);
    AnsweredPageBool(true)
      expertDomainChange(value)
    }, 2000),
    []
  );

  const handleChangeCuration = (values) => {
    AnsweredPageBool(true);
    updatePageNoAnswered(0)
    const newExpertCuration = values.map((val) => ({
      value: val,
      label: val,
      name: val,
    }));
    changeCurationStatus(values.length > 0 ? "pending" : "")
    setCurationFilter(values.length > 0 ? "pending" : "");
    expertCurationChange(newExpertCuration);
    setSelectedFilters(values); // Keep UI and logic in sync
    setHeadFilter(values); // Also sync headFilter
  };


  const handleChangeDomain = (value) => {
    // getScrollPositionInExpertOpen(null)
    // updatePageNoAnswered(0);
    // AnsweredPageBool(true)
    const newVal = value.map((obj) => ({
      value: obj,
      label: obj,
      name: obj,
    }));
    setDomain(newVal);
    debouncedFetchOptions([...newVal]);
  };

  // Sync initial values from Redux state


  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%" }}>
      {show === 1 && (
        <div style={{ flex: 1 }}>
          <Select
            size="large"
            mode="multiple"
            allowClear
            options={curationFilter}
            style={{ width: "100%" }}
            placeholder="Select Curation"
            onChange={handleChangeCuration}
            value={pageState.expertCuration}
            optionLabelProp="label"
            filterOption={(input, option) =>
              option?.label.toLowerCase().includes(input.toLowerCase())
            }
            dropdownStyle={{ textAlign: "left" }}
            maxTagCount={0}
            maxTagPlaceholder={`${pageState.expertCuration.length} selected`}
          />
        </div>
      )}

      {show === 2 && (
        <div style={{ flex: 1 }}>
          <Select
            size="large"
            mode="multiple"
            allowClear
            options={options}
            style={{ width: "260px" }}
            placeholder="Select Domains"
            onChange={handleChangeDomain}
            value={domain}
            optionLabelProp="label"
            filterOption={(input, option) =>
              option?.label.toLowerCase().includes(input.toLowerCase())
            }
            dropdownStyle={{ textAlign: "left" }}
            maxTagCount={0}
            maxTagPlaceholder={`${domain.length} selected`}
          />
        </div>
      )}
    </div>
  );
};

export default NewNestedSelect;

